var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
      [
        _c(
          "q-form",
          { ref: "editForm" },
          [
            _c(
              "c-card",
              {
                staticClass: "cardClassDetailForm",
                attrs: { title: "LBL0010600" },
              },
              [
                _c(
                  "template",
                  { slot: "card-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: {
                                isSubmit: _vm.isSave,
                                url: _vm.saveUrl,
                                param: _vm.folder,
                                mappingType: _vm.mappingType,
                                label: "LBLSAVE",
                                icon: "save",
                              },
                              on: {
                                beforeAction: _vm.saveFolder,
                                btnCallback: _vm.saveCallback,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                    },
                    [
                      _c("c-text", {
                        attrs: {
                          required: "",
                          editable: _vm.editable,
                          label: "LBL0010601",
                          name: "folderName",
                        },
                        model: {
                          value: _vm.folder.folderName,
                          callback: function ($$v) {
                            _vm.$set(_vm.folder, "folderName", $$v)
                          },
                          expression: "folder.folderName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                    },
                    [
                      _c("c-text", {
                        attrs: {
                          afterIcon: [
                            {
                              name: "search",
                              click: true,
                              callbackName: "searchFolder",
                              color: "teal",
                            },
                            {
                              name: "close",
                              click: true,
                              callbackName: "removeFolder",
                              color: "red",
                            },
                          ],
                          disabled: true,
                          editable: _vm.editable,
                          label: "LBL0010602",
                          placeholder: "MSG0010064",
                          name: "parentFolderName",
                        },
                        on: {
                          searchFolder: () => {
                            _vm.isFolderOpen = true
                          },
                          removeFolder: _vm.removeFolder,
                        },
                        model: {
                          value: _vm.folder.parentFolderName,
                          callback: function ($$v) {
                            _vm.$set(_vm.folder, "parentFolderName", $$v)
                          },
                          expression: "folder.parentFolderName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                    },
                    [
                      _c("c-text", {
                        attrs: {
                          disabled: true,
                          label: "LBL0010603",
                          name: "folderLevel",
                        },
                        model: {
                          value: _vm.folder.folderLevel,
                          callback: function ($$v) {
                            _vm.$set(_vm.folder, "folderLevel", $$v)
                          },
                          expression: "folder.folderLevel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                    },
                    [
                      _c("c-plant", {
                        attrs: {
                          required: "",
                          disabled: _vm.disabled,
                          editable: _vm.editable,
                          type: "edit",
                          name: "plantCd",
                        },
                        model: {
                          value: _vm.folder.plantCd,
                          callback: function ($$v) {
                            _vm.$set(_vm.folder, "plantCd", $$v)
                          },
                          expression: "folder.plantCd",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                    },
                    [
                      _c("c-radio", {
                        attrs: {
                          editable: _vm.editable,
                          comboItems: _vm.useFlagItems,
                          label: "사용여부",
                          name: "useFlag",
                        },
                        model: {
                          value: _vm.folder.useFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.folder, "useFlag", $$v)
                          },
                          expression: "folder.useFlag",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                    },
                    [
                      _c("c-text", {
                        attrs: {
                          editable: _vm.editable,
                          type: "number",
                          label: "LBLSORTORDER",
                          name: "sortOrder",
                        },
                        model: {
                          value: _vm.folder.sortOrder,
                          callback: function ($$v) {
                            _vm.$set(_vm.folder, "sortOrder", $$v)
                          },
                          expression: "folder.sortOrder",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "q-dialog",
          {
            ref: "folderDialog",
            attrs: { persistent: "" },
            model: {
              value: _vm.isFolderOpen,
              callback: function ($$v) {
                _vm.isFolderOpen = $$v
              },
              expression: "isFolderOpen",
            },
          },
          [
            _c(
              "q-card",
              { staticClass: "folder-card" },
              [
                _c(
                  "q-card-section",
                  {
                    staticClass:
                      "row items-center q-pb-none px-2 py-1 bg-orange-custom text-white",
                  },
                  [
                    _c("div", { staticClass: "text-h6" }, [
                      _vm._v(_vm._s(_vm.$label("LBL0010604"))),
                    ]),
                    _c("q-space"),
                    _c("q-btn", {
                      attrs: { icon: "done", flat: "", round: "", dense: "" },
                      on: { click: _vm.selectFolder },
                    }),
                    _c("q-btn", {
                      directives: [
                        { name: "close-popup", rawName: "v-close-popup" },
                      ],
                      attrs: { icon: "close", flat: "", round: "", dense: "" },
                    }),
                  ],
                  1
                ),
                _c(
                  "q-item",
                  [
                    _c(
                      "q-item-section",
                      [
                        _c(
                          "q-item-label",
                          { attrs: { caption: "" } },
                          [
                            _c(
                              "q-chip",
                              {
                                attrs: {
                                  outline: "",
                                  square: "",
                                  color: "primary",
                                  "text-color": "white",
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.folderName) + " ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("q-separator"),
                _c(
                  "q-card-section",
                  { staticClass: "folder-content p-2" },
                  [
                    _c("q-tree", {
                      ref: "folderTree",
                      attrs: {
                        nodes: _vm.folderTree,
                        "node-key": "opmFolderId",
                        "label-key": "folderName",
                        "children-key": "children",
                        "no-nodes-label":
                          _vm.$comm.getLangMessage("MSG0010065"),
                        "no-results-label": "",
                        "default-expand-all": false,
                        "selected-color": "primary",
                        selected: _vm.selectedFolder,
                      },
                      on: {
                        "update:selected": function ($event) {
                          _vm.selectedFolder = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }